import styled from '@emotion/styled';
import { Flex } from 'antd';

export const FormContainer = styled(Flex)`
  max-width: 30%;
  margin: 0 auto;
  min-height: 70vh;

  @media (max-width: 768px) {
    max-width: 60%;
  }

  @media (max-width: 480px) {
    max-width: 90%;
    padding: 0 1rem;
    min-height: 80vh;
  }
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 24px;
`;

export const ButtonGroup = styled(Flex)`
  gap: 1rem;
  align-self: center;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
  }
`;

export const SuccessMessage = styled.p`
  text-align: center;
  margin-top: 16px;
  color: green;

  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 0 0.5rem;
  }
`;
